import type { Question } from "../survey/schema";

// ElevenLabs Scribe v2 keyterms 制約 (2026-07-07 確認):
//   - 最大 1000 個 / 各 50 文字以内 / 各 5 単語以内
//   - 20% cost surcharge (受容: PoC は精度優先)
//   - >100 keyterms なら 20 秒最低課金 → 100 個以下に抑える
// spec: docs/decisions/2026-06-21-stt-provider-elevenlabs.md (追記)

const KANJI_DIGITS: Record<number, string[]> = {
  1: ["いち", "一"],
  2: ["に", "二"],
  3: ["さん", "三"],
  4: ["よん", "し", "四"],
  5: ["ご", "五"],
  6: ["ろく", "六"],
  7: ["なな", "しち", "七"],
  8: ["はち", "八"],
  9: ["きゅう", "く", "九"],
  10: ["じゅう", "十"],
};

// scale Q に対する keyterms: 数値 (アラビア数字 + かな + 漢数字) + Label。
// 「三人」誤認識を避けるため「1」「2」「3」... を優先させる。
function scaleKeyterms(min: number, max: number, minLabel: string, maxLabel: string): string[] {
  const terms: string[] = [];
  for (let n = min; n <= max; n++) {
    terms.push(String(n));
    const kanji = KANJI_DIGITS[n];
    if (kanji) terms.push(...kanji);
  }
  // Label も biasing 対象に (質問文中の重要語)
  if (minLabel) terms.push(minLabel);
  if (maxLabel && maxLabel !== minLabel) terms.push(maxLabel);
  return dedupe(terms);
}

function dedupe(arr: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const s of arr) {
    if (!s) continue;
    const trimmed = s.trim();
    if (!trimmed || seen.has(trimmed)) continue;
    seen.add(trimmed);
    out.push(trimmed);
  }
  return out;
}

// 質問タイプごとに STT biasing 用の keyterms を返す。
// short / long は現状 [] (質問文中の固有名詞抽出は未実装。実データ収集後に拡張)。
export function buildKeytermsForQuestion(q: Question): string[] {
  if (q.type === "scale") {
    return scaleKeyterms(q.min, q.max, q.minLabel, q.maxLabel);
  }
  return [];
}
